import { jsx as o } from "react/jsx-runtime";

import { forwardRef as r } from "react";

import e from "../hooks/useFieldSubscription.js";

import t from "../hooks/useGlobals.js";

const s = o => o.inline, i = r(((r, i) => {
    const {model: m, components: n} = t(), a = e(m, s) ? n.ViewChooser : n.ModalDatePicker;
    return o(a, {
        ...r,
        ref: i
    });
}));

export { i as default };
//# sourceMappingURL=Root.js.map
